import { ApiService } from "../..";

export const sendVerificationCode = (data: {
  phoneNumber: string;
  action: "login" | "bind";
}) => {
  return ApiService.baseAction("sms/verification_code", { data }, "post");
};
